import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"



  interface Props {
    additionalClasses?: string
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    additionalClasses: {}
  },
  setup(__props: any) {

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card py-2 px-2 shadow-3 h-100", props.additionalClasses])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})